import styled from "styled-components"

const Item = styled.li`
  background-color: ${({theme}) => theme.colors.greys.white};
  border-radius: 2px;
  display: inline-block;
  margin-right: 3px;
  padding: 3px 6px;
  &:hover {
    background-color: ${({theme}) => theme.colors.greys.lightest};
  }
`

export default Item
